import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"
import ReactMarkdown from "react-markdown"
import SEO from "../components/seo"

const ComponentName = ({ data }) => {
  const { content, title, date } = data.news

  return (
    <Layout>
      <SEO title={`ORLEN | ${title}`} />
      <Sublinks />
      <div className="section-article markdown">
        <Infolinia customStyle="infolinia-black d-none d-md-flex js-infolinia" />
        <article>
          <div className="container">
            <div className="text-md-center">
              <div className="news-title">
                <p className="data mb-4">{date}</p>
                <h1 className="mb-4">{title}</h1>
              </div>
              <div className="news-body text-left">
                <ReactMarkdown
                  source={content}
                  transformImageUri={uri =>
                    uri.startsWith("http")
                      ? uri
                      : `${(process.env.IMAGE_BASE_URL === undefined) ? "" : process.env.IMAGE_BASE_URL}${uri}`
                  }
                  escapeHtml={false}
                />
                <div className="my-3 my-xl-5 text-center">
                  <Link
                    to="/news-list"
                    className="btn btn-rounded btn-secondary btn-bordered"
                  >
                    Back to news <span className="icon-arr-right ml-3 color-red"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!) {
    news:strapiNewsPosts(slug: { eq: $slug }) {
      title
      content
      date
    }
  }
`

export default ComponentName
